module.exports = __webpack_public_path__ + "static/media/DSC07457.747aad01.JPG";